import { useMutation } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { extractApiErrorMessage, type DownloadFileResult, toDownloadFileResult } from './download-utils'

export interface RestaurarRubricaRequest {
  file: File
  tpAmb?: string
  tbAmb?: string
  responseFormat?: 'json' | 'zip'
}

export function useRestaurarRubrica() {
  const token = useAccessToken()
  const user = useCurrentUser()

  return useMutation({
    mutationFn: async ({
      file,
      tpAmb,
      tbAmb,
      responseFormat
    }: RestaurarRubricaRequest): Promise<DownloadFileResult> => {
      if (!file) {
        throw new Error('Arquivo é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const formData = new FormData()
      formData.append('file', file)
      if (tpAmb) formData.append('tpAmb', tpAmb)
      if (tbAmb) formData.append('tbAmb', tbAmb)
      if (responseFormat) formData.append('response_format', responseFormat)

      try {
        const response = await api.post<Blob>('/previdenciario/restaurar/rubrica', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          responseType: 'blob'
        })

        if (!response.data) {
          throw new Error('Erro ao restaurar rubrica')
        }

        return toDownloadFileResult(response, 'rubricas-restauradas.zip')
      } catch (error) {
        throw new Error(await extractApiErrorMessage(error, 'Erro ao restaurar rubrica'))
      }
    }
  })
}
